import { render } from "./LinkAnalyticsPerfection.vue?vue&type=template&id=1481e065&scoped=true"
import script from "./LinkAnalyticsPerfection.vue?vue&type=script&lang=js"
export * from "./LinkAnalyticsPerfection.vue?vue&type=script&lang=js"

import "@/css/components/link-analytics-perfection.css?vue&type=style&index=0&id=1481e065&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1481e065"]])

export default __exports__